<template>
    <VWidget
        class="my-numerics-widget"
        :page="props.widgetPage"
        :primary="props.widgetPrimary"
        :secondary="props.widgetSecondary"
        :space="props.widgetSpace"
    >
        <VWidgetHeader :title="title" v-show="title"> </VWidgetHeader>

        <ul class="numerics-list">
            <template v-for="goal in numerics" :key="goal.id">
                <li class="numerics-list__item">
                    <RouterLink
                        class="prevent-close numeric-goal-selector"
                        :numeric-id="goal.id"
                        :to="{ query: { numeric: goal.id } }"
                    >
                        <VNumericCard :goal="goal"></VNumericCard>
                    </RouterLink>
                </li>
            </template>
        </ul>
    </VWidget>
</template>
<script setup lang="ts">
// Components
import VWidget from '../components/VWidget.vue';
import VWidgetHeader from '../components/VWidgetHeader.vue';

import VNumericCard from '../components/VNumericCard.vue';

// Other
import { defineProps, PropType, ref, toRef, watch } from 'vue';
import NumericsService from '@/core/Services/NumericService';
import INumeric from '@/core/Models/INumeric';
import { $error } from '@/utils/app-utils';
import IQueryNumericRequest from '@/core/Requests/IQueryNumericRequest';
import { useNumericMutator } from '@/mixins/NumericApi';

const props = defineProps({
    filters: { type: Object as PropType<IQueryNumericRequest>, default: () => ({}) },

    title: { type: String, default: '' },

    widgetPage: { type: Boolean, default: false },
    widgetSpace: { type: Boolean, default: false },
    widgetPrimary: { type: Boolean, default: false },
    widgetSecondary: { type: Boolean, default: false },
});

let filters = toRef(props, 'filters');
let numerics = ref([] as INumeric[]);

const { trackMutations } = useNumericMutator(null, filters);

watch(filters, fetchNumerics, { immediate: true });

async function fetchNumerics() {
    try {
        numerics.value = await NumericsService.queryAsync(filters.value);
        trackMutations(numerics.value);
    } catch (error) {
        $error(error);
    }
}
</script>

<style lang="scss">
.numerics-list {
    &__item {
        margin-bottom: 0.5rem;
    }
}
</style>
